import { createBrowserRouter } from "react-router";

import { AuthGate } from "../auth/auth-gate";
import { LeftSidebarLayout } from "../templates/layouts/left-sidebar-layout";
import { RouteErrorScreen } from "../templates/layouts/route-error-screen";
import { routePaths } from "./route-paths";

export const appRouter = createBrowserRouter([
  {
    path: routePaths.authCallback,
    errorElement: <RouteErrorScreen />,
    lazy: { Component: async () => (await import("../../screens/auth-callback/auth-callback-screen")).AuthCallbackScreen },
  },
  {
    element: (
      <AuthGate>
        <LeftSidebarLayout />
      </AuthGate>
    ),
    errorElement: <RouteErrorScreen />,
    children: [
      {
        path: routePaths.dashboard,
        lazy: { Component: async () => (await import("../../screens/dashboard/dashboard-screen")).DashboardScreen },
      },
      {
        path: routePaths.portfolios,
        lazy: { Component: async () => (await import("../../screens/portfolios/portfolios-screen")).PortfoliosScreen },
      },
      {
        path: routePaths.portfolioHealth,
        lazy: { Component: async () => (await import("../../screens/portfolio-health/portfolio-health-screen")).PortfolioHealthScreen },
      },
      {
        path: routePaths.portfolioDetail,
        lazy: { Component: async () => (await import("../../screens/portfolio-detail/portfolio-detail-screen")).PortfolioDetailScreen },
      },
      {
        path: routePaths.instruments,
        lazy: { Component: async () => (await import("../../screens/instruments/instruments-screen")).InstrumentsScreen },
      },
      {
        path: routePaths.instrumentDetail,
        lazy: { Component: async () => (await import("../../screens/instrument-detail/instrument-detail-screen")).InstrumentDetailScreen },
      },
      {
        path: routePaths.corporateActions,
        lazy: { Component: async () => (await import("../../screens/corporate-actions/corporate-actions-screen")).CorporateActionsScreen },
      },
      {
        path: routePaths.watchlist,
        lazy: { Component: async () => (await import("../../screens/watchlist/watchlist-screen")).WatchlistScreen },
      },
      {
        path: routePaths.brokers,
        lazy: { Component: async () => (await import("../../screens/brokers/brokers-screen")).BrokersScreen },
      },
      {
        path: routePaths.instrumentMapping,
        lazy: {
          Component: async () => (await import("../../screens/instrument-mapping/instrument-mapping-screen")).InstrumentMappingScreen,
        },
      },
      {
        path: routePaths.admin,
        lazy: { Component: async () => (await import("../../screens/admin/admin-screen")).AdminScreen },
      },
      {
        path: "*",
        lazy: { Component: async () => (await import("../../screens/not-found/not-found-screen")).NotFoundScreen },
      },
    ],
  },
]);
